// Constants shared between the web client and the Auth0 post-login
// Actions. Keeping the deny reason in a single place lets us match on
// it exactly without coupling to internal `OAuthError.message` shape
// (which the SDK derives from `error_description` and which can be
// overridden by `api.access.deny(reason, userMessage)`).

// Reason string passed to `api.access.deny(...)` by the
// enforce-allowlist Action when a verified email is not on the
// allow-list. Mirror any change here in
// infra/auth0/actions/enforce-allowlist.js (and the deployed Action
// in the Auth0 dashboard) — drift between them is what this constant
// exists to prevent.
export const ALLOWLIST_DENIAL_REASON = 'not_on_allowlist';

// OAuth error code Auth0 surfaces on access-denied responses. Used to
// narrow the matcher so we only treat allow-list denials specially
// when the underlying OAuth code is access_denied.
export const AUTH0_ACCESS_DENIED_CODE = 'access_denied';

// Custom JWT claim set by the set-admin-claim Action for verified
// @wolisho.com emails (on both the access and ID tokens; the SPA reads
// it off the ID token via `useAuth0().user`). Mirror any change here in
// infra/auth0/actions/set-admin-claim.js and
// apps/api-cf/src/common/auth/claims.ts (and the deployed Action in
// the Auth0 dashboard). The web check is purely cosmetic — the API
// only trusts the claim on the signed access token.
export const IS_ADMIN_CLAIM = 'https://wolisho/is_admin';
